import React from "react";
import back from "../../assets/Arrow.svg";
import "./backButton.css";

const BackButton = ({ onClick }) => {
  return (
    <div>
      <img onClick={onClick} className="button-size" src={back} />
    </div>
  );
};

export default BackButton;
